import { graphql } from '../../graphql';

export const signInByEmail = graphql(`
  mutation SignInByEmail($emailAndPassword: EmailAndPasswordInput!) {
    signIn(input: { emailAndPassword: $emailAndPassword }) {
      profile {
        ... on CompanyProfile {
          id
        }
      }
      errors {
        message
        path
      }
    }
  }
`);
